/**
 * Mounts once inside <BrowserRouter> and walks every navigation to
 * keep `document.title` in sync with the current route via the
 * `PAGE_TITLES` map. Renders nothing.
 *
 * Pages that need a *dynamic* title (e.g. "Study: Q4 Demand Plan")
 * call `useDocumentTitle(...)` directly — that override stays in
 * place while the page is mounted, and on unmount this component
 * snaps the title back to the route default.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_TITLE } from "@/hooks/useDocumentTitle";
import { titleForPath } from "@/lib/pageTitles";

const SUFFIX = " · UpSynQ";

export function RouteTitleSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = titleForPath(pathname);
    document.title = t ? `${t}${SUFFIX}` : DEFAULT_TITLE;
  }, [pathname]);
  return null;
}
